// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__R7sXj","footer-content":"Footer_footer-content__cByHS","footer-socials":"Footer_footer-socials__yq7K9"};